import React from 'react';
const ACService = () => <div className="service-page"><h1>AC Service</h1><p>AC repair, maintenance, and installation by certified professionals.</p></div>;
export default ACService;
